import { render } from "./Postbacks.vue?vue&type=template&id=e3aeeff8&ts=true"
import script from "./Postbacks.vue?vue&type=script&lang=ts"
export * from "./Postbacks.vue?vue&type=script&lang=ts"

import "./Postbacks.vue?vue&type=style&index=0&id=e3aeeff8&lang=scss"

import exportComponent from "/root/source/core/frontend/affiliate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QInput,QOptionGroup,QField});
